import React, { useState, useEffect } from 'react';
import {
  Box, Button, Card, CardContent, FormControl, Grid, InputLabel,
  MenuItem, Select, TextField, Typography
} from '@mui/material';
import { Save, Cancel } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { rewardsAPI } from '../../services/api';

export default function RewardForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    pointsCost: '',
    category: 'food',
    validFrom: new Date().toISOString().split('T')[0],
    validUntil: '',
    status: 'active',
    stock: ''
  });

  useEffect(() => {
    if (isEdit) {
      // Load reward data for editing
    }
  }, [id]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await rewardsAPI.updateReward(id, formData);
      } else {
        await rewardsAPI.createReward(formData);
      }
      navigate('/rewards');
    } catch (error) {
      console.error('Error saving reward:', error);
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {isEdit ? 'Edit Reward' : 'Create Reward'}
      </Typography>

      <form onSubmit={handleSubmit}>
        <Card>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Reward Title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  multiline
                  rows={3}
                  label="Description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  type="number"
                  label="Points Cost"
                  name="pointsCost"
                  value={formData.pointsCost}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth required>
                  <InputLabel>Category</InputLabel>
                  <Select
                    name="category"
                    value={formData.category}
                    label="Category"
                    onChange={handleChange}
                  >
                    <MenuItem value="food">Food & Dining</MenuItem>
                    <MenuItem value="fitness">Fitness</MenuItem>
                    <MenuItem value="wellness">Wellness</MenuItem>
                    <MenuItem value="retail">Retail</MenuItem>
                    <MenuItem value="entertainment">Entertainment</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Valid From"
                  name="validFrom"
                  value={formData.validFrom}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Valid Until"
                  name="validUntil"
                  value={formData.validUntil}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    startIcon={<Cancel />}
                    onClick={() => navigate('/rewards')}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    startIcon={<Save />}
                  >
                    {isEdit ? 'Update' : 'Create'} Reward
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </form>
    </Box>
  );
}
